import classnames from 'classnames'
import React from 'react'

import styles from './ToggleAnimation.module.css'

interface ToggleProps {
  className?: string
  selected: boolean
}

const ToggleAnimation = ({ selected, className }: ToggleProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 35 35"
      width="100"
      height="100"
      className={classnames(className, styles.toggle, {
        [`${styles.toggleIsActive}`]: selected,
      })}
    >
      <g
        className="toggle-outline"
        transform="translate(16.6166664759,16.6666666667)"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          fillOpacity="0"
          stroke="rgb(255,255,255)"
          strokeWidth="1.5"
          d="M11.25,0 C11.25,3.313999891281128 8.564000129699707,6 5.25,6 C5.25,6 -5.25,6 -5.25,6 C-8.564000129699707,6 -11.25,3.313999891281128 -11.25,0 C-11.25,-3.313999891281128 -8.564000129699707,-6 -5.25,-6 C-5.25,-6 5.25,-6 5.25,-6 C8.564000129699707,-6 11.25,-3.313999891281128 11.25,0z"
        />
      </g>

      <g className={styles.sticks}>
        <g transform="translate(4.05066680908,4.66666666667)">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="rgb(255,255,255)"
            strokeWidth="1.5"
            d="M6.447999954223633,9 C6.447999954223633,9 6.447999954223633,11.875 6.447999954223633,11.875 C6.447999954223633,11.875 6.447999954223633,15 6.447999954223633,15"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="rgb(255,255,255)"
            strokeWidth="1.5"
            d="M9.447999954223633,9 C9.447999954223633,9 9.447999954223633,11.75 9.447999954223633,11.75 C9.447999954223633,11.75 9.447999954223633,15 9.447999954223633,15"
          />
        </g>
      </g>

      <g
        opacity="0"
        className={styles.dot}
        transform="translate(21.7403329213,16.6666666667)"
      >
        <path
          fill="rgb(255,74,125)"
          d="M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
        />
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          fillOpacity="0"
          strokeMiterlimit="10"
          stroke="rgb(255,255,255)"
          strokeWidth="1.5"
          d="M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
        />
      </g>
    </svg>
  )
}

export default ToggleAnimation
